<template>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 heading">Marketplace Purchase</div>
    </div>
    <div class="row m-0">
      <div class="col-md-12">
        <ul class="crumb-trail">
          <li
            class="col-md-3 col-sm-3 col-lg-3 p-0"
            v-for="(case_item, index) in cases"
            :key="index"
            :class="{
              'is-active-slide col-xs-6': current_slide_number === index,
              'col-xs-2': current_slide_number !== index,
              completed_slide: current_slide_number > index
            }"
          >
            <div class="crumb">
              <img
                src="/static/images/icons/circle_check.svg"
                class="breadcrumb-img"
                alt="check-icon"
              />
              <span>{{ case_item.title }}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div
      class="row"
      v-for="(case_item, index) in cases"
      :key="index"
      :class="{ 'is-active-slide': current_slide_number === index }"
    >
      <div class="col-md-12 main-content" v-if="case_item.title === 'Select Services'">
        <select-service-upgrade
          ref="selectService"
          :serviceSelected="serviceSelected"
          :currentService="currentService"
          :selectedRecords="selectedRecords"
          :teamMemberData="selectedTeamData"
          :teamMemberProRata="teamMemberProRata"
        ></select-service-upgrade>
      </div>
      <!-- Payment Method -->
      <div
        class="col-lg-12 col-md-12 col-sm-12 main-content"
        v-if="case_item.title === 'Payment Method'"
      >
        <payment-method
          :paymentOptionsList="paymentOptionsList"
          :totalPrice="totalPrice"
          @uID="uID"
          @paymentOpts="paymentOptions"
        ></payment-method>
      </div>
      <!-- Billing Info -->
      <div
        class="col-lg-12 col-md-12 col-sm-12 main-content"
        v-if="case_item.title === 'Billing info'"
      >
        <billing-info
          :purchaseOrder="payment_option == 2"
          :current_slide="current_slide_number"
          ref="billingInfo"
          :billingData="billingData"
          @saveBillingInfo="saveBillingInfo"
        ></billing-info>
      </div>
      <!-- Confirmation Page -->
      <div
        class="col-lg-12 col-md-12 col-sm-12 main-content"
        v-if="case_item.title === 'Confirmation'"
      >
        <confirmation-tab
          @editSlide="navigateToSlide"
          :serviceId="serviceId"
          :selectedRecords="selectedRecords"
          :selectedRecordsProdCls="selectedRecordsProdCls"
          :selectedRecordsProdClsRat="selectedRecordsProdClsRat"
          :selectedRecordsRegPathwy="selectedRecordsRegPathwy"
          :serviceSelected="serviceSelected"
          :teamMemberData="selectedTeamData"
          :paymentSelected="paymentSelected"
          :billingDetails="billingDetails"
          :serviceMarket="serviceMarket"
          :serviceCountry="serviceCountry"
          :serviceCountries="serviceCountries"
          :regIntelPrice="regIntelPrice"
          :bundleDetails="bundleDetails"
          :defaultCountry="defaultCountry"
          :paymentStatus="paymentStatus"
          :totalPrice="totalPrice"
          :proRataData="proRataData"
          :teamMemberProRata="teamMemberProRata"
          :purchaseType="'upgrade'"
        ></confirmation-tab>
      </div>
    </div>

    <div class="row case-slider__navigation m-0">
      <div
        class="prev col-lg-2 col-md-2 col-sm-2 col-xs-4"
        v-if="current_slide_number != 0 && !paymentStatus && payment_option !== 1"
      >
        <button class="custom-padding emergo-blue-button" @click="prevSlide">Back</button>
      </div>
      <div
        :class="{
          'col-xs-4 col-md-offset-7 col-lg-offset-8 col-sm-offset-7 cancel_first_slide':
            current_slide_number == 0,
          'col-sm-offset-5 col-md-offset-5 col-lg-offset-6 cancel_other_slide hide-first-cancel':
            current_slide_number != 0
        }"
        class="cancel col-lg-2 col-md-2 col-sm-2"
        v-if="!paymentStatus && payment_option !== 1"
      >
        <button class="custom-padding emergo-white-button" @click="showcancelModal">Cancel</button>
      </div>
      <div
        class="next"
        :class="{
          'col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right': paymentStatus,
          'col-xs-8 col-lg-2 col-md-3 col-sm-3': !paymentStatus
        }"
        v-if="cases.length - 1 == current_slide_number"
      >
        <button
          class="btn emergo-green-button btn-padding"
          v-if="payment_option !== 1"
          @click="confirmSubscription"
        >
          Confirm
        </button>
        <button
          class="btn emergo-green-button btn-padding"
          v-if="payment_option == 1"
          @click="confirmCC"
        >
          Confirm
        </button>
      </div>
      <div
        class="next"
        :class="{
          'col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right': payment_option == 1,
          'col-xs-8 col-lg-2 col-md-3 col-sm-3': payment_option !== 1
        }"
        v-if="current_slide_number === 0 && serviceSelected.id === 16"
      >
        <button class="btn emergo-green-button btn-padding" @click="getProRata">Continue</button>
      </div>
      <div
        class="next"
        :class="{
          'col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right': payment_option == 1,
          'col-xs-8 col-lg-2 col-md-3 col-sm-3': payment_option !== 1
        }"
        v-else-if="cases.length - 1 != current_slide_number"
      >
        <button class="btn emergo-green-button btn-padding" @click="nextSlide">Continue</button>
      </div>
      <div
        :class="{
          'hide-first-cancel': current_slide_number == 0,
          'cancel_other_slide col-xs-12': current_slide_number != 0
        }"
        class="hide-second-cancel cancel col-lg-2 col-md-2 col-sm-2"
      >
        <button class="emergo-white-button custom-padding" @click="showcancelModal">Cancel</button>
      </div>
      <div class="modal fade" id="MymodalPreventScript">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal">
                <span aria-hidden="true">&times;</span>
              </button>
              <div class="card text-center">
                <div class="card-body">
                  <div class="card-title">
                    <p class="first-card-title">Are you sure you would like</p>
                    <p class="secnd-card-title">to leave this page</p>
                  </div>
                  <div class="card-text">
                    <p class="first-card-text">You have made changes to your purchases</p>
                    <p class="scnd-card-text">that will be lost if you decide to leave</p>
                  </div>
                </div>
                <div class="row card-footer">
                  <div class="col-sm-6 pb_10">
                    <button class="btn btn-block emergo-white-button" @click="cancelled()">
                      Leave Page
                    </button>
                  </div>
                  <div class="col-sm-6">
                    <button class="btn btn-block emergo-blue-button" data-dismiss="modal">
                      Stay on Page
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <pro-rata-modal
      :proRataData="proRataData"
      @nextSlide="nextSlide"
      :serviceSelected="serviceSelected"
      :selectedRecords="selectedRecords"
    ></pro-rata-modal>
    <error-modal :errorMessage="errorMessage"></error-modal>
    <success-modal
      :showMessage="true"
      :successMessage="successMessage"
      :redirection="redirection"
      :payment_option="payment_option"
      renew="true"
    ></success-modal>
    <warn-modal :warnMessage="warnMessage" :redirection="redirection"></warn-modal>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>
<script>
import $ from 'jquery';
import { filter, findIndex } from 'lodash';
import moment from 'moment';
import EventBus from '../../../utils/event-bus';
import ErrorModal from '../../Common/ErrorModal.vue';
import SuccessModal from '../../Common/SuccessModal.vue';
import WarnModal from '../../Common/WarningModal.vue';
import ProRataModal from './ProRataModal.vue';
import SelectServiceUpgrade from './SelectServiceUpgrade.vue';
import PaymentMethod from './PaymentMethod.vue';
import BillingInfo from './BillingInfo.vue';
import ConfirmationTab from './ConfirmationTab.vue';
import Loader from '../../UIComponents/Loader.vue';
import {
  getPlans,
  getAccountAddons,
  getPlanAddons,
  getAddonDetails,
  getPaymentModes,
  getBillingInfo,
  postBillingInfo,
  updateBillingInfo,
  postPlan,
  getProRata,
  upgradeAccountAddon
} from '../../../apis/psm';
import { getSubscribedPlans } from '../../../apis/plans';
import {
  getRegIntelComplementaryCountry,
  postDefaultCountry
} from '../../../apis/regulatoryIntelligence';
import { getPaymentDetails } from '../../../apis/chasePaymentAPIs';
import { getUserData } from '../../../apis/profile';
import { getTeamMemberAddonProRata } from '../../../apis/team';

export default {
  components: {
    SelectServiceUpgrade,
    PaymentMethod,
    BillingInfo,
    ConfirmationTab,
    Loader,
    ErrorModal,
    SuccessModal,
    WarnModal,
    ProRataModal
  },
  data() {
    return {
      serviceCountries: [],
      defaultCountry: 0, // To check if the service is to be upgraded
      showErrorMsg: false,
      showMultipleErrorMsg: false,
      showDefaultErrorMsg: false,
      serviceMarket: '',
      serviceCountry: '',
      redirection: '',
      errorMessage: '',
      successMessage: '',
      warnMessage: '',
      serviceId: null,
      loaderStatus: false,
      current_slide_number: 0,
      accountAddons: [],
      addonDetails: [],
      plansList: [],
      paymentOptionsList: [],
      payment_option: '',
      paymentSelected: {},
      subscribedPlans: [],
      optionsMap: new Map(),
      cases: [
        {
          id: 1,
          title: 'Select Services'
        },
        {
          id: 2,
          title: 'Payment Method'
        },
        {
          id: 3,
          title: 'Billing info'
        },
        {
          id: 4,
          title: 'Confirmation'
        }
      ],
      regPathwayOptions: [
        {
          name: '1-Report',
          desc: '$299',
          value: 1,
          storage: '0',
          price: '299'
        },
        {
          name: '2-Report',
          desc: '$598',
          value: 2,
          storage: '0',
          price: '598'
        },
        {
          name: '3-Report',
          desc: '$897',
          value: 3,
          storage: '0',
          price: '897'
        },
        {
          name: '4-Report',
          desc: '$1196',
          value: 4,
          storage: '0',
          price: '1196'
        }
      ],
      prodClassOptions: [
        {
          name: '1-Use',
          desc: '$99',
          value: 1,
          storage: '0',
          price: '99'
        },
        {
          name: '2-Uses',
          desc: '$198',
          value: 2,
          storage: '0',
          price: '198'
        },
        {
          name: '3-Uses',
          desc: '$297',
          value: 3,
          storage: '0',
          price: '297'
        },
        {
          name: '4-Uses',
          desc: '$396',
          value: 4,
          storage: '0',
          price: '396'
        },
        {
          name: '5-Uses',
          desc: '$495',
          value: 5,
          storage: '0',
          price: '495'
        }
      ],
      prodClassRatOptions: [
        {
          name: '1-Use',
          desc: '$199',
          value: 1,
          storage: '0',
          price: '199'
        },
        {
          name: '2-Uses',
          desc: '$398',
          value: 2,
          storage: '0',
          price: '398'
        },
        {
          name: '3-Uses',
          desc: '$597',
          value: 3,
          storage: '0',
          price: '597'
        },
        {
          name: '4-Uses',
          desc: '$796',
          value: 4,
          storage: '0',
          price: '796'
        },
        {
          name: '5-Uses',
          desc: '$995',
          value: 5,
          storage: '0',
          price: '995'
        }
      ],
      options: [
        {
          name: '250 & 2GB',
          desc: 'Included',
          value: 250,
          storage: '2097152',
          price: '0'
        },
        {
          name: '1000 & 4GB',
          desc: '+$200',
          value: 1000,
          storage: '4194304',
          price: '200'
        },
        {
          name: '2000 & 6GB',
          desc: '+$300',
          value: 2000,
          storage: '6291456',
          price: '300'
        },
        {
          name: '3000 & 8GB',
          desc: '+$400',
          value: 3000,
          storage: '8388608',
          price: '400'
        },
        {
          name: '4000 & 10GB',
          desc: '+$500',
          value: 4000,
          storage: '10485760',
          price: '500'
        },
        {
          name: '5000 & 12GB',
          desc: '+$600',
          value: 5000,
          storage: '12582912',
          price: '600'
        }
      ],
      selectedTeamData: null,
      teamMemberProRata: null,
      records: '',
      selectedRecords: '',
      selectedRecordsProdCls: '',
      selectedRecordsProdClsRat: '',
      selectedRecordsRegPathwy: '',
      accountAddonId: null,
      serviceSelected: {},
      billingData: {},
      totalPrice: 0,
      planAddons: [],
      billingDetails: {},
      billingAPI: '',
      recordsPrice: 0,
      recordCurrentUtilization: null,
      countries: {},
      regIntelPrice: 0,
      regIntelServiceType: '',
      selectAllService: false,
      storageCurrentUtilization: '',
      regIntelDefaultMarket: '',
      bundleDetails: {
        newBundle: false,
        expirationDate: ''
      },
      uIDVal: '',
      paymentStatus: false,
      paymentId: '',
      orderId: '',
      transactionId: '',
      PRODUCT_CLASSIFICATION: 7,
      REGULATORY_ESSENTIALS_REPORT: 15,
      CLASSIFICATION_RATIONALE_REPORT: 9,
      CLASSIFICATION_RATIONALE_REPORT_EXP_RV: 10,
      currentService: {},
      currentServiceId: null,
      userData: {},
      proRataData: {},
      validFrom: '',
      validUntil: ''
    };
  },
  methods: {
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },

    bundleExpirationDate(values) {
      this.bundleDetails = values;
    },
    indexOfSelectedService(id) {
      return findIndex(this.serviceSelected, (val) => val.id === id);
    },
    showcancelModal() {
      $('#MymodalPreventScript').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    cancelled() {
      $('#MymodalPreventScript').modal('hide');
      this.$router.push('/layout/market-place');
    },
    navigateToSlide(slideNumber) {
      this.current_slide_number = slideNumber;
    },
    async getPlansDisplayList() {
      this.plansList = [];
      this.plansList = await getPlans();

      if (!this.selectedTeamData) {
        this.serviceSelected = this.plansList.find((plan) => this.serviceId === plan.id);
        this.currentService = this.subscribedPlans.find(
          (plan) => this.currentServiceId === plan.id
        );
      }
    },
    async getAvailableAccountAddons() {
      this.accountAddons = await getAccountAddons();
      this.planAddons = await getPlanAddons(this.plansList[0].id);
    },
    async getAddonDetails() {
      this.addonDetails = await getAddonDetails(this.userData.account_id);
      const index = this.addonDetails.findIndex((addon) => addon.units === 'RECORDS');
      if (index >= 0) {
        this.records = this.addonDetails[index];
        this.recordCurrentUtilization = this.records.current_utilization;
      }
      const storageId = this.addonDetails.findIndex((addon) => addon.units === 'STORAGE');
      if (storageId >= 0) {
        const storage = this.addonDetails[index];
        this.storageCurrentUtilization = storage.current_utilization;
      }
      const regindex = this.addonDetails.findIndex((addon) => addon.units === 'COUNTRIES');
      if (regindex >= 0) {
        this.countries = this.addonDetails[regindex];
      }
    },
    uID(value) {
      this.uIDVal = value;
    },
    async paymentModesList() {
      this.paymentOptionsList = await getPaymentModes();
    },
    async getBillingInfo() {
      this.billingData = await getBillingInfo();
    },
    paymentOptions(values) {
      this.payment_option = values;
    },
    todayDate() {
      return moment().utc().format('YYYY-MM-DD HH:mm:ss');
    },
    renewStartDate() {
      return moment.utc('12/01/2021').format('YYYY-MM-DD HH:mm:ss');
    },
    renewEndDate() {
      return moment.utc('01/01/2022').format('YYYY-MM-DD HH:mm:ss');
    },
    RegIntellMarketValues(values) {
      this.serviceMarket = values.Market;
      this.serviceCountry = values.Country;
      this.serviceCountries = values.Countries;
      this.regIntelDefaultMarket = values.Default_Market;
      if (
        this.serviceMarket === 'upgrade' &&
        this.countries &&
        new Date() > new Date(this.countries.valid_from) &&
        new Date() < new Date(this.countries.valid_until) &&
        this.regIntelServiceType === 'premium'
      ) {
        const date1 = moment.utc(new Date());
        const date2 = moment.utc(this.countries.valid_until).add(2, 'days');
        const diff = date2.diff(date1, 'days');
        const price = (diff / 365) * this.serviceCountries.length * 99;
        this.regIntelPrice = price.toFixed(2);
      } else if (this.serviceMarket === 'upgrade') {
        const price = this.serviceCountries.length * 99;
        this.regIntelPrice = Math.trunc(price);
      } else if (this.serviceMarket === 'all') {
        this.regIntelPrice = 249;
      } else {
        this.regIntelPrice = 0;
      }
    },
    clearErrorMessage() {
      this.showMultipleErrorMsg = false;
    },
    clearDefaultMessageErrorMessage() {
      this.showDefaultErrorMsg = false;
    },
    async getProRata() {
      this.loaderStatus = true;
      const data = {
        account_id: this.userData.account_id,
        bundle_id: this.serviceSelected.id,
        date_time: moment(),
        user_id: this.userData.id
      };
      this.proRataData = await getProRata(data);
      this.loaderStatus = false;
      $('#ProRataModal').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    setPriceDataForTeamMemberUpgrade() {
      this.totalPrice = this.teamMemberProRata
        ? this.teamMemberProRata.netPrice
        : this.selectedRecords?.value * 100;
    },
    async nextSlide() {
      this.setPriceDataForServicesAndTeamMember();
    },
    async setPriceDataForServicesAndTeamMember() {
      if (this.current_slide_number === 0) {
        this.showErrorMsg = false;
        if (this.serviceSelected.id === 2) {
          if (!this.defaultCountry && !this.regIntelDefaultMarket) {
            this.showErrorMsg = true;
            return;
          }
          if (!this.defaultCountry && this.regIntelDefaultMarket && !this.serviceCountry) {
            this.showErrorMsg = true;
            return;
          }
          if (this.defaultCountry && this.serviceMarket === '') {
            this.showErrorMsg = true;
            return;
          }
          if (this.serviceMarket === 'upgrade' && this.serviceCountries.length === 0) {
            this.showErrorMsg = true;
            return;
          }
          this.showErrorMsg = false;
          if (
            !this.defaultCountry &&
            this.regIntelDefaultMarket &&
            this.serviceCountry &&
            this.serviceMarket === ''
          ) {
            this.current_slide_number = 3;
            return;
          }
        }
        if (this.selectedRecords === 'displayMessage') {
          this.warnMessage = 'Please contact RAMSHelp@ul.com';
          this.redirection = '/layout/market-place';
          $('#warnMsgModal').modal('show');
          return;
        }
        if (this.selectedTeamData) {
          this.setPriceDataForTeamMemberUpgrade();
        } else if (
          (this.serviceSelected.id === 15 || this.serviceSelected.id === 16) &&
          this.proRataData.creditPrice
        ) {
          const Price = this.serviceSelected.price - this.proRataData.creditPrice;
          if (Math.sign(Price) === 1) {
            this.totalPrice = parseInt(Price, 10);
          } else this.totalPrice = 0;
        } else if (
          this.serviceSelected.price &&
          this.selectedRecords &&
          this.selectedRecords.price
        ) {
          if (
            this.serviceSelected.id === 1 ||
            this.serviceSelected.id === 13 ||
            this.serviceSelected.id === 14
          ) {
            if (this.selectedRecords) {
              this.totalPrice = parseInt(this.selectedRecords.price, 10);
            }
          }
        }
      }
      if (this.current_slide_number === 1) {
        if (this.payment_option === '') {
          this.errorMessage = 'Please select any payment method';
          $('#ErrorMsgModal').modal('show');
          return;
        }
        if (this.payment_option === 1) {
          this.loaderStatus = true;
          const resp = await getPaymentDetails(this.uIDVal);
          this.paymentId = resp.id;
          // change order_id to cus_ref_number
          this.orderId = resp.order_id;
          this.transactionId = resp.txn_ref;
          if (this.paymentId && resp.customer_ref_num) {
            this.loaderStatus = false;
            this.paymentStatus = true;
            this.current_slide_number += 2;
          } else {
            this.loaderStatus = false;
            this.errorMessage =
              'Payment processing/failed with the selected method. Please wait or try again';
            $('#ErrorMsgModal').modal('show');
          }
        } else {
          this.current_slide_number += 1;
        }
      } else if (this.current_slide_number === 2) {
        this.$refs.billingInfo[0].$v.$touch();
        if (this.$refs.billingInfo[0].$v.$invalid) {
          return;
        }
        let payment = filter(this.paymentOptionsList, {
          id: this.payment_option
        });
        if (this.billingDetails.purchase_order) {
          payment = [{ id: 3, mode: 'Puchase Order' }];
        }
        [this.paymentSelected] = payment;
        this.current_slide_number += 1;
      } else if (this.serviceSelected && this.serviceSelected.id === this.PRODUCT_CLASSIFICATION) {
        this.payment_option = 1;
        let payment = filter(this.paymentOptionsList, {
          id: this.payment_option
        });
        if (this.billingDetails.purchase_order) {
          payment = [{ id: 3, mode: 'Puchase Order' }];
        }
        [this.paymentSelected] = payment;
        this.current_slide_number += 3;
      } else {
        this.current_slide_number += 1;
      }
    },
    prevSlide() {
      if (this.current_slide_number === 3) {
        if (
          this.serviceSelected.id === 2 &&
          !this.defaultCountry &&
          this.regIntelDefaultMarket &&
          this.serviceCountry &&
          this.serviceMarket === '' &&
          this.serviceSelected
        ) {
          this.current_slide_number = 0;
        } else if (this.payment_option === 1) {
          this.current_slide_number -= 2;
        } else {
          this.current_slide_number -= 1;
        }
      } else {
        this.current_slide_number -= 1;
      }
    },
    recordsSelected(value) {
      this.selectedRecords = value;
    },
    regpathwayNosSelected(value) {
      this.selectedRecordsRegPathwy = value;
    },
    prodClassNosSelected(value) {
      this.selectedRecordsProdCls = value;
    },
    prodClassRatNosSelected(value) {
      this.selectedRecordsProdClsRat = value;
    },
    saveBillingInfo(details) {
      this.billingAPI = details.apiType;
      this.billingDetails = details.billingInfo;
    },
    async getSubscribedPlansList() {
      this.subscribedPlans = await getSubscribedPlans(this.userData.account_id);
    },
    async getRegIntelComplementaryCountry() {
      this.defaultCountry = await getRegIntelComplementaryCountry(this.userData.account_id);
    },
    serviceValidity() {
      const planIndex = this.subscribedPlans.findIndex((obj) => obj.id === this.serviceSelected.id);
      if (planIndex >= 0) {
        const planDetails = this.subscribedPlans[planIndex];
        this.validFrom = moment(planDetails.valid_from).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
        this.regIntelServiceType = planDetails.service_type;
        if (planDetails && planDetails.service_type !== 'premium') {
          this.validUntil = moment(planDetails.valid_until)
            .add(1, 'years')
            .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
        } else {
          this.validUntil = moment(planDetails.valid_until).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
        }
      } else {
        this.validFrom = moment.utc();
        this.validUntil = moment.utc().add(1, 'years').subtract(1, 'days');
      }
    },
    async addBillingDetails() {
      let response;
      if (this.billingAPI === 'post') {
        response = await postBillingInfo(this.billingDetails);
      } else if (this.billingAPI === 'put' && this.billingData) {
        this.billingDetails.id = this.billingData.id;
        response = await updateBillingInfo(this.billingDetails);
      } else if (this.billingData) {
        return 'success';
      } else {
        return 'error';
      }
      if (response.message === 'success' && response.status_code === 200) {
        return response.message;
      }
      this.clearNotifications();
      this.$notify({
        type: 'error',
        title: 'Error',
        text: response.message,
        group: 'custom-notification'
      });
      return 'error';
    },
    async handlePaymentForServices() {
      this.serviceValidity();
      const addon = [];
      let operation = 7;
      if (
        this.serviceSelected.id === 1 ||
        this.serviceSelected.id === 13 ||
        this.serviceSelected.id === 14
      ) {
        addon.push({
          account: false,
          active: true,
          id: 2,
          price: this.selectedRecords.price,
          valid_from: this.validFrom,
          valid_until: this.validUntil,
          volume: this.selectedRecords.storage
        });
        addon.push({
          account: false,
          active: true,
          id: 3,
          price: this.selectedRecords.price,
          valid_from: this.validFrom,
          valid_until: this.validUntil,
          volume: this.selectedRecords.value
        });
      } else if (
        this.serviceSelected.id === this.CLASSIFICATION_RATIONALE_REPORT ||
        this.serviceSelected.id === this.CLASSIFICATION_RATIONALE_REPORT_EXP_RV
      ) {
        if (this.serviceSelected.id === this.CLASSIFICATION_RATIONALE_REPORT) {
          addon.push({
            account: false,
            active: true,
            id: 6,
            price: this.selectedRecordsProdClsRat.price,
            valid_from: this.validFrom,
            valid_until: this.validUntil,
            volume: this.selectedRecordsProdClsRat.value
          });
        } else if (this.serviceSelected.id === this.CLASSIFICATION_RATIONALE_REPORT_EXP_RV) {
          addon.push({
            account: false,
            active: true,
            id: 7,
            price: 1499,
            valid_from: this.validFrom,
            valid_until: this.validUntil,
            volume: 1
          });
        }
      }
      if (
        this.serviceSelected.id === 2 ||
        this.serviceSelected.id === 13 ||
        this.serviceSelected.id === 14
      ) {
        if (this.regIntelDefaultMarket && !this.defaultCountry) {
          const formData = {
            country_id: this.serviceCountry.country_id,
            operation: 18,
            payment_mode: 4,
            total_amount: 0
          };
          const resp = await postDefaultCountry(formData);
          if (resp.message !== 'success' || resp.status_code !== 200) {
            this.clearNotifications();
            this.$notify({
              type: 'error',
              title: 'Error',
              text: resp.message,
              group: 'custom-notification'
            });
            return;
          }
        }
        const selectedIds = this.serviceCountries.map((a) => a.country_id);
        addon.push({
          account: false,
          active: true,
          id: 11,
          price: this.regIntelPrice ? this.regIntelPrice : 0,
          valid_from: this.validFrom,
          valid_until: this.validUntil,
          volume: this.serviceCountries.length ? this.serviceCountries.length : 1,
          regulatory_intelligence: {
            all:
              this.serviceMarket === 'all' ||
              this.serviceSelected.id === 13 ||
              this.serviceSelected.id === 14,
            country_id: selectedIds
          }
        });
        if (this.serviceSelected.id === 2) {
          operation = 7;
        }
      }
      if (this.serviceSelected.id === 16) {
        addon.push({
          account: false,
          active: true,
          id: 13,
          price: this.serviceSelected.price,
          valid_from: this.validFrom,
          valid_until: this.validUntil,
          volume: this.serviceCountries.length ? this.serviceCountries.length : 1,
          regulatory_reports: {
            all: true,
            country_id: []
          }
        });
      }
      const formData = {
        account_id: JSON.parse(localStorage.getItem('userData')).account_id,
        active: true,
        add_on: addon,
        operation,
        payment_mode: this.billingDetails.purchase_order ? 3 : this.payment_option,
        plan_id: this.serviceSelected.id,
        plan_price: this.serviceSelected.price,
        service_type: 'premium',
        total_amount: this.totalPrice ? this.totalPrice : 0,
        valid_from: this.validFrom,
        valid_until: this.validUntil
      };
      if (this.billingDetails.purchase_order) {
        formData.purchase_order = this.billingDetails.purchase_order;
      }
      if (this.payment_option === 1 && this.paymentStatus) {
        formData.payment_id = this.paymentId;
        formData.order_id = this.orderId;
        formData.txn_ref = this.transactionId;
        formData.operation = 8;
      }
      if (this.serviceSelected.id === 16 && this.proRataData.creditPrice) {
        formData.credit_amount = this.proRataData.creditPrice;
      }
      const resp = await postPlan(formData);
      this.showSuccessToaster(resp);
    },
    showSuccessToaster(resp) {
      let message;
      if (this.selectedTeamData) {
        if (!this.paymentStatus) {
          message = `Team Member ${
            this.selectedTeamData.isRenewal ? 'Renewal' : 'Upgrade'
          } request for ${this.selectedRecords.value} members have been submitted`;
        } else {
          message = `${this.selectedRecords.value} Team Members have been ${
            this.selectedTeamData.isRenewal ? 'Renewed' : 'Upgraded'
          }`;
        }
      } else if (!this.paymentStatus) {
        message = `Subscription Upgrade request for ${this.serviceSelected.name} have been submitted`;
      } else {
        message = `Subscription for ${this.serviceSelected.name} have been upgraded`;
      }
      if (resp.message === 'success' && resp.status_code === 200) {
        if (this.payment_option !== 1) {
          if (!this.paymentStatus) {
            this.successMessage = message;
          } else {
            this.successMessage = message;
          }
          this.redirection = '/layout/market-place';
          $('#successMsgModal').modal({
            backdrop: 'static',
            keyboard: false
          });
        } else {
          this.loaderStatus = false;
          this.paymentStatus = true;
          const payment = filter(this.paymentOptionsList, {
            id: this.payment_option
          });
          [this.paymentSelected] = payment;
          this.current_slide_number += 2;
        }
      } else {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: resp.message,
          group: 'custom-notification'
        });
      }
    },
    confirmCC() {
      this.successMessage = `Credit card payment successful and subscription has been activated`;
      this.redirection = '/layout/market-place';
      $('#successMsgModal').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    async handlePaymentForTeamMember() {
      const {
        isRenewal,
        total_limit: totalLimit,
        default_limit: defaultLimit
      } = this.selectedTeamData;
      let teamValidUntil;
      if (
        this.selectedTeamData &&
        this.selectedTeamData.valid_until > this.todayDate() &&
        this.selectedTeamData.total_limit > this.selectedTeamData.default_limit
      ) {
        teamValidUntil = this.selectedTeamData.valid_until;
      } else {
        teamValidUntil = moment
          .utc()
          .add(1, 'years')
          .subtract(1, 'days')
          .format('YYYY-MM-DD HH:mm:ss');
      }
      if (isRenewal) {
        teamValidUntil = moment
          .utc(this.selectedTeamData.valid_until)
          .add(1, 'years')
          .format('MM/DD/YYYY');
      }
      let totalPrice;
      if (totalLimit <= defaultLimit || isRenewal) totalPrice = this.selectedRecords.value * 100;
      else totalPrice = this.teamMemberProRata.netPrice;
      const formData = {
        account_id: JSON.parse(localStorage.getItem('userData')).account_id,
        add_on: [
          {
            account: true,
            active: true,
            id: 1,
            price: this.selectedRecords.price,
            valid_from: isRenewal
              ? moment(this.selectedTeamData.valid_until)
                  .add(1, 'days')
                  .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
              : moment(this.selectedTeamData.valid_from).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
            valid_until: moment(teamValidUntil).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
            volume: isRenewal
              ? this.selectedTeamData.default_limit + this.selectedRecords.value
              : this.selectedTeamData.total_limit + this.selectedRecords.value,
            requested_volume: this.selectedRecords.value
          }
        ],
        operation: isRenewal ? 20 : 12,
        payment_mode: this.billingDetails.purchase_order ? 3 : this.payment_option,
        total_amount: totalPrice
      };
      if (this.billingDetails.purchase_order) {
        formData.purchase_order = this.billingDetails.purchase_order;
      }
      if (this.payment_option === 1 && this.paymentStatus) {
        formData.payment_id = this.paymentId;
        formData.order_id = this.orderId;
        formData.txn_ref = this.transactionId;
        formData.operation = isRenewal ? 22 : 13;
      }
      const response = await upgradeAccountAddon(formData);
      this.showSuccessToaster(response);
    },
    async confirmSubscription() {
      this.loaderStatus = true;
      let response;
      if (
        this.serviceSelected.id === 2 &&
        this.serviceMarket === '' &&
        this.regIntelDefaultMarket &&
        !this.defaultCountry
      ) {
        const formData = {
          country_id: this.serviceCountry.country_id,
          operation: 18,
          payment_mode: 4,
          total_amount: 0
        };
        const resp = await postDefaultCountry(formData);
        this.loaderStatus = false;
        if (resp.message === 'success' && resp.status_code === 200) {
          this.successMessage = `Default country subscription for ${this.serviceSelected.name} have been successful`;
          this.redirection = '/layout/market-place';
          $('#successMsgModal').modal({
            backdrop: 'static',
            keyboard: false
          });
        } else {
          this.clearNotifications();
          this.$notify({
            type: 'error',
            title: 'Error',
            text: resp.message,
            group: 'custom-notification'
          });
        }
      } else {
        if (this.payment_option !== 1) {
          response = await this.addBillingDetails();
        }
        if (this.payment_option === 1 || response === 'success') {
          if (!this.selectedTeamData) this.handlePaymentForServices();
          else this.handlePaymentForTeamMember();
        }
      }
    },
    async initialCall() {
      this.loaderStatus = true;
      await this.getSubscribedPlansList();
      await this.getPlansDisplayList();
      await this.getAvailableAccountAddons();
      await this.getAddonDetails();
      await this.paymentModesList();
      await this.getBillingInfo();
      await this.getRegIntelComplementaryCountry();
      this.serviceValidity();
      this.loaderStatus = false;
    },
    validateServiceIds() {
      const { upgradeService, upgradeTeamMember } = this.$route.params;
      const teamMemberData =
        upgradeTeamMember || JSON.parse(sessionStorage.getItem('upgradeTeamMember'));
      const serviceData = upgradeService || JSON.parse(sessionStorage.getItem('upgradeServices'));
      if (teamMemberData) this.handleTeamMemberData(teamMemberData);
      else if (serviceData) this.handleUpgradeServiceData(serviceData);
      else this.$router.push('/layout/dashboard');
    },
    async handleTeamMemberData(teamMemberData) {
      this.selectedTeamData = teamMemberData.service;
      this.selectedRecords = teamMemberData.selection;
      this.checkIsProRataNeeded();
      this.setServiceAndMembersInSession('upgradeTeamMember', teamMemberData);
      sessionStorage.removeItem('upgradeServices');
    },

    async checkIsProRataNeeded() {
      const {
        total_limit: totalLimit,
        default_limit: defaultLimit,
        isRenewal
      } = this.selectedTeamData;
      if (totalLimit <= defaultLimit || isRenewal)
        this.totalPrice = this.selectedRecords?.value * 100;
      else {
        this.loaderStatus = true;
        this.teamMemberProRata = await getTeamMemberAddonProRata({
          account_id: this.userData.account_id,
          team_member_count: this.selectedRecords.value
        });
        this.loaderStatus = false;
      }
    },
    setServiceAndMembersInSession(key, value) {
      if (!sessionStorage.getItem(key)) {
        sessionStorage.setItem(key, JSON.stringify(value));
      }
    },
    handleUpgradeServiceData(serviceData) {
      this.selectedTeamData = null;
      this.serviceId = serviceData.serviceId;
      this.currentServiceId = serviceData.currentServiceId;
      if ([1, 13, 14].includes(this.serviceId)) this.selectedRecords = serviceData.selection;
      this.setServiceAndMembersInSession('upgradeServices', serviceData);
      sessionStorage.removeItem('upgradeTeamMember');
    },
    async successClickMethod() {
      window.removeEventListener('successClick', this.successClickMethod);
      this.loaderStatus = true;
      const resp = await getPaymentDetails(this.uIDVal);
      this.paymentId = resp.id;
      // change order_id to cus_ref_number
      this.orderId = resp.order_id;
      this.transactionId = resp.txn_ref;
      if (this.paymentId && resp.customer_ref_num) {
        this.loaderStatus = false;
        this.paymentStatus = true;
        const payment = filter(this.paymentOptionsList, {
          id: this.payment_option
        });
        [this.paymentSelected] = payment;
        await this.confirmSubscription();
      }
    }
  },
  beforeRouteLeave(_to, _from, next) {
    sessionStorage.removeItem('upgradeTeamMember');
    sessionStorage.removeItem('upgradeServices');
    next();
  },
  async mounted() {
    this.userData = localStorage.getItem('userData')
      ? JSON.parse(localStorage.getItem('userData'))
      : await getUserData();
    this.validateServiceIds();
    this.initialCall();
    EventBus.$on('upgradeService', async (data) => {
      if (!data.isTeamMember) {
        this.handleUpgradeServiceData(data);
        await this.initialCall();
      } else {
        this.handleTeamMemberData(data);
      }
      window.addEventListener('successClick', this.successClickMethod);
      this.current_slide_number = 0;
      this.payment_option = '';
      this.paymentStatus = false;
    });
    window.addEventListener('successClick', this.successClickMethod);
  }
};
</script>
<style scoped>
.heading {
  margin-top: 20px;
  font-size: 24px;
  line-height: 28px;
  color: #0b3c61;
}
@media (width: 768px) {
  .crumb > .breadcrumb-img {
    vertical-align: middle;
    margin-right: 2px;
    height: 18px;
    width: 18px;
  }
  .crumb-trail > li > .crumb {
    font-size: 15px;
    padding: 20px 5px 20px 28px;
  }
}
@media (min-width: 769px) and (max-width: 1024px) {
  .crumb-trail > li > .crumb {
    font-size: 16px;
    padding: 20px 0px 20px 28px;
  }
}
@media screen and (max-width: 1024px) {
  .crumb-trail > li:not(:first-child) > .crumb:after {
    left: -11px;
  }
  .crumb-trail > li.is-active-slide > .crumb {
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
  }
  .crumb-trail > li:not(:first-child) > .crumb:before {
    left: -1px;
  }
}
@media screen and (max-width: 767px) {
  .completed_slide > .crumb > .breadcrumb-img {
    margin-right: 0px;
    height: 30px;
    width: 30px;
  }
  .crumb-trail > li.completed_slide > .crumb {
    padding: 8px;
  }
  .crumb-trail > li:not(:first-child).completed_slide > .crumb {
    padding: 8px 0px 8px 0px;
    text-align: right;
  }
  .crumb-trail > li > .crumb {
    font-size: 0px;
    padding: 12px;
  }
  .crumb-trail > li.is-active-slide > .crumb {
    font-size: 16px;
  }
  .crumb-trail > li.is-active-slide + li > .crumb:after {
    border-left-color: #0b3c61;
  }
  .crumb-trail > li:not(:first-child) > .crumb:after {
    border-top: 22px solid transparent;
    border-bottom: 24px solid transparent;
    border-left: 16px solid #f3f5fb;
  }
  .crumb-trail > li:not(:first-child) > .crumb:before {
    border-top: 22px solid transparent;
    border-bottom: 25px solid transparent;
    border-left: 16px solid #fff;
  }
}
.crumb-trail {
  margin-top: 20px;
  list-style: none;
  padding: 0px;
}
.p-0 {
  padding: 0px;
}
.completed_slide > .crumb > .breadcrumb-img {
  display: inline;
}
.breadcrumb-img {
  vertical-align: top;
  margin-right: 6px;
  height: 23px;
  width: 23px;
  display: none;
}
.crumb {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 23px;
  color: #828282;
  padding: 20px;
  position: relative;
  cursor: pointer;
  background: #f3f5fa;
  text-align: center;
}
.is-active-slide > .crumb {
  background: #0b3c61;
  color: #ffffff;
}
.crumb-trail > li.is-active-slide + li > .crumb:after {
  border-left-color: #0b3c61;
}
.pull-left {
  float: left;
}
.crumb-trail > li:first-child > .crumb {
  border-top-left-radius: 40px;
  border-bottom-left-radius: 40px;
}
.crumb-trail > li:last-child > .crumb {
  border-top-right-radius: 40px;
  border-bottom-right-radius: 40px;
}
.crumb-trail > li:not(:first-child) > .crumb {
  margin-left: 10px;
}
li:not(:first-child) > .crumb:after {
  content: '';
  border-top: 30px solid transparent;
  border-bottom: 33px solid transparent;
  border-left: 24px solid #f3f5fa;
  position: absolute;
  left: -10px;
  top: 0;
  z-index: 1;
}
li:not(:first-child) > .crumb:before {
  content: '';
  border-top: 30px solid transparent;
  border-bottom: 33px solid transparent;
  border-left: 24px solid #fff;
  position: absolute;
  left: 0;
  top: 0;
}

.main-content {
  display: none;
}
.is-active-slide .main-content {
  display: block;
}
.custom-padding {
  padding: 6px 31px;
}
.btn-padding {
  padding: 6px 50px;
}
.case-slider__navigation {
  position: relative;
  margin-top: 21px;
  margin-bottom: 32px;
}
.regTracker {
  color: #0b3c61;
  font-size: 16px;
  line-height: 19px;
  font-weight: bold;
}
.regIntelligence {
  color: rgba(0, 0, 0, 0.7);
  font-size: 16px;
  line-height: 19px;
  font-weight: normal;
}
.regTracker-desc {
  padding-left: 28px;
  color: #828282;
  font-size: 14px;
  line-height: 16px;
}
.single-service,
.dollar-month,
.dollar-year {
  color: #0b3c61;
  font-size: 16px;
  line-height: 19px;
  font-weight: bold;
}
.bundle-service,
.dollar-per-month,
.dollar-per-year {
  color: rgba(0, 0, 0, 0.7);
  font-size: 16px;
  line-height: 19px;
  font-weight: normal;
}
p.selct-services {
  padding: 22px 0px 5px 20px;
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  color: rgba(0, 0, 0, 0.7);
}
p.add-on-option {
  padding: 0px 0px 5px 20px;
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  color: rgba(0, 0, 0, 0.7);
}
.table.table-top {
  margin-top: 14px;
}
.box-border-wrapper.selected-box {
  border: 3px solid #4c9e45;
}
.mr-bt-10 {
  margin-bottom: 10px;
}
.box-border-wrapper {
  padding-top: 15px;
  padding-bottom: 15px;
  border: 1px solid #d3d6d9;
  border-radius: 10px;
}
.select-services-line {
  margin-top: 43px;
}
.consulting-add-on {
  color: rgba(0, 0, 0, 0.7);
  font-size: 16px;
  line-height: 19px;
  padding-left: 20px;
}
.premium-service,
.dollar-per-hour {
  color: rgba(0, 0, 0, 0.7);
  font-size: 16px;
  line-height: 19px;
  font-weight: normal;
}

.txt-alg-lft {
  text-align: left;
}

/* for radio button*/
[type='radio']:checked,
[type='radio']:not(:checked) {
  position: absolute;
  left: -9999px;
}
[type='radio']:checked + label,
[type='radio']:not(:checked) + label {
  position: relative;
  padding-left: 28px;
  cursor: pointer;
}
[type='radio']:checked + label:before,
[type='radio']:not(:checked) + label:before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 18px;
  height: 18px;
  border: 1px solid #0b3c61;
  border-radius: 100%;
  background: #fff;
}
[type='radio']:checked + label:after,
[type='radio']:not(:checked) + label:after {
  content: '';
  width: 12px;
  height: 12px;
  background: #0b3c61;
  position: absolute;
  top: 3px;
  left: 3px;
  border-radius: 100%;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
[type='radio']:not(:checked) + label:after {
  opacity: 0;
  -webkit-transform: scale(0);
  transform: scale(0);
}
[type='radio']:checked + label:after {
  opacity: 1;
  -webkit-transform: scale(1);
  transform: scale(1);
}

/* for checkbox */
.styled-checkbox {
  position: absolute;
  opacity: 0;
}
.styled-checkbox + label {
  position: relative;
  cursor: pointer;
  padding: 0;
}
.styled-checkbox + label:before {
  content: '';
  margin-right: 10px;
  margin-top: 4px;
  display: inline-block;
  vertical-align: text-top;
  width: 14px;
  height: 14px;
  border: 1px solid #0b3c61;
  border-radius: 1px;
}
.styled-checkbox:checked + label:after {
  content: '';
  position: absolute;
  left: 2px;
  top: 10px;
  background: white;
  width: 2px;
  height: 2px;
  box-shadow: 2px 0 0 white, 4px 0 0 white, 4px -2px 0 white, 4px -4px 0 white, 4px -6px 0 white,
    4px -8px 0 white;
  transform: rotate(45deg);
}
.styled-checkbox:checked + label:before {
  background: #0b3c61;
}
/* Modal */
.modal .modal-dialog .modal-content {
  border-radius: 10px;
}
.modal .modal-dialog .modal-content .modal-header {
  background: #f2f2f2;
  border-radius: 10px;
}
.card .card-body .card-title p.first-card-title {
  font-size: 25px;
  padding-top: 30px;
  color: rgba(0, 0, 0, 0.7);
}
.card .card-body .card-title p.secnd-card-title {
  font-size: 25px;
  color: rgba(0, 0, 0, 0.7);
}
.card .card-body .card-text p.first-card-text {
  padding-top: 30px;
  font-size: 18px;
  font-weight: 300;
  margin-bottom: 0px;
  color: rgba(0, 0, 0, 0.7);
  line-height: 19px;
}
.card .card-body .card-text p.scnd-card-text {
  font-size: 18px;
  font-weight: 300;
  color: rgba(0, 0, 0, 0.7);
  padding-bottom: 30px;
}
.stay-on-page {
  background: #0b3c61;
  border: 1px solid #0b3c61;
  box-sizing: border-box;
  border-radius: 20px;
  color: #f2f2f2;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  text-align: center;
  padding-top: 8px;
  padding-bottom: 6px;
}
.leave-page {
  background: #f2f2f2;
  border: 1px solid #0b3c61;
  box-sizing: border-box;
  border-radius: 20px;
  color: #0b3c61;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  text-align: center;
  padding-bottom: 6px;
}
.card .card-footer {
  padding-bottom: 20px;
}
.pb_10 {
  padding-bottom: 10px;
}
.modal-header .close {
  background: none;
  opacity: 0.5;
  height: 17px;
  line-height: 17px;
  color: #828282;
  width: 17px;
  border-radius: 20px;
  font-weight: 300;
  outline: none;
  font-size: 32px;
}
@media screen and (min-width: 768px) {
  .prev {
    text-align: left;
  }
  .cancel {
    padding-right: 0px;
    padding-left: 0px;
    text-align: end;
  }
  .hide-second-cancel {
    display: none;
  }
}
@media screen and (max-width: 767px) {
  .hide-first-cancel {
    display: none;
  }
  .cancel_first_slide {
    padding-right: 0px;
  }
  .prev {
    padding-right: 0px;
    text-align: left;
  }
  .custom-padding {
    width: 100%;
  }
  .cancel_other_slide {
    padding-right: 16px;
    padding-left: 14px;
    padding-top: 16px;
  }
}
</style>
